import { useEffect } from 'react'

/**
 * 防止閃閃
 * SurveyJS 在手機版有機率沒補上 .sd-root-modern--mobile，導致版面閃動。
 * 掛在 App.js 的 Content()，全站問卷共用一份，各問卷 Agree.js 不需再自行實作。
 */
export const useMobileRootClass = () => {
  useEffect(() => {
    let observer = null
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })
    }, 100) // 100ms 後再判斷

    // 清除
    return () => {
      clearTimeout(timeout)
      if (observer) observer.disconnect()
    }
  }, [])
}
